<template>
    <div class="CaseInfoBox">
        <!-- <div class="toolBox">
            <Button @click="back">返回</Button>
        </div> -->
        <div class="boxLeft">
            <div class="infoTitle">
                <h2>{{info.title}}</h2>
                <p>{{info.createTime | formatTime}}</p>
            </div>
            <div class="dicom">
                <dicom-card :show="false" viewable v-for="(i, index) in imageList" :key="index" :data="i" :size="300"></dicom-card>
            </div>
            <div>
                <h6 class="title">【病史描述】</h6>
                <p class="artical pw">{{info.topic}}</p>
            </div>
            <div>
                <h6 class="title">【问题思考】</h6>
                <p class="artical pw">{{info.answer}}</p>
            </div>
            <div v-if="ifShow&&info.pathologyResults">
                <h6 class="title">【病理结果】</h6>
                <p class="artical pw">{{info.pathologyResults}}</p>
            </div>
            <div v-if="ifShow&&info.diagnosis">
                <h6 class="title">【诊断结果】</h6>
                <p class="artical pw">{{info.diagnosis}}</p>
            </div>
            <div v-if="ifShow">
                <h6 class="title">【征象描述】</h6>
                <p class="artical pw">{{info.symptomDescription}}</p>
            </div>
            <div v-if="ifShow">
                <h6 class="title">【诊断思路】</h6>
                <p class="artical pw">{{info.diagnoseThinking}}</p>
            </div>
            <div v-if="ifShow">
                <h6 class="title">【鉴别诊断】</h6>
                <p class="artical pw">{{info.differentialDiagnosis}}</p>
            </div>
            <div class="hide" v-if="!ifShow">
                隐藏内容，留言后显示
            </div>
            <div class="toolBox">
                <Button @click="back" type="primary">返回</Button>
            </div>
        </div>
        <div class="boxRight">
            <leave-message ref="message" @submit="submit" :messages="messages"></leave-message>
        </div>
    </div>    
</template>

<script>
import  DicomCard from "../dicomUploader/curd/widgets/DicomCard"
import LeaveMessage from "../LeaveMessage/LeaveMessage"
export default {
    components: {
        DicomCard,
        LeaveMessage
    },
    props: {
        id: {}
    },
    data() {
        return {
            info: {
                
            },
            messages: [],
            ifShow: false
        }
    },
    computed: {
        imageList() {
            if(this.info.imageInfo&&this.info.imageInfo!='{}') {
                return JSON.parse(this.info.imageInfo)
            }
        }
    },
    methods: {
        back() {
            this.$emit('cancel')
        },
        submit(value) {
            let data = {
                extension: value,
                ownerId: this.info.id
            }
            this.$api.data.addAttention(data).then(res => {
                this.$refs.message.reSet()
                this.searchMessage()
            })
        },
        searchMessage() {
            let data = {
                ownerId: this.info.id
            }
            this.$api.data.findAttention(data).then(res => {
                this.messages = res.data
                this.ifShow = res.ifShow
            })
        }
    },
    mounted() {
        let data = {
            id: this.id
        }
        this.$api.data.findIdTypicalCase(data).then(res => {
            this.info =res.data
            this.searchMessage()
        })
    }
}
</script>

<style lang="scss" scoped>
.CaseInfoBox{
    padding: 10px 0 80px 0;
    &::after{
        content: "";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }
    .toolBox{
        margin: 20px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        border-top: 1px solid #dddddd;
        padding-top: 10px;
    }
    .boxLeft{
        width: 70%;
        border-right: 1px solid #dddddd;
        padding-right: 5px;
        float: left;
            font-size: 18px;
        .infoTitle{
            text-align: center;
            border-bottom: 1px solid #dddddd;
            margin-bottom: 20px;
        }
        .dicom{
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .title{
            font-size: 18px;
            color: #2d8cf0;
        }
        .artical{
            font-size: 16px;
            padding: 5px 30px;
            // text-indent: 2em;
        }
    }
    .boxRight{
        width: 30%;
        padding-left: 10px;
        float: left;
    }
    .hide{
        margin-top: 10px;
        text-align: center;
        height: 100px;
        line-height: 100px;
        border: 1px dashed #dddddd;
    }
}
    
</style>



// WEBPACK FOOTER //
// src/components/ClassicCase/CaseInfo.vue